//长整型转为double保留两位小数
function longToDecimal(params) {
  if(params == '' || params == null || params == undefined){
    return params
  }else{
    return (params / 100).toFixed(2)
  }
}

//长整型转为double保留两位小数  (除10000)
function longToDecimal2(params) {
  if(params == '' || params == null || params == undefined){
    return params
  }else{
    return (params / 10000).toFixed(2)
  }
}

//double转为长整型，扩大一百倍
function DecimalToLong(params) {
  if(params == '' || params == null || params == undefined){
    return params
  }else{
    return  Math.round(parseFloat((params*100).toFixed(10)))
  }
}

//长整型除100
function longToInt(params) {
  return params / 100
}

//数字转千分位
function regexNum(params){
  params = Number(params)
  //看数字中是否包含“.”,如果不包含，则不需要保留两位小数
  if(params.toString().indexOf('.') != -1){
     var n = parseFloat(params.toString()).toFixed(2);
  }else{
     var n = parseFloat(params.toString()).toFixed(0);
  }
     var re = /(\d{1,3})(?=(\d{3})+(?:\.))/g;
      return n.replace(re, "$1,"); 
}


//转化原理
//全角空格unicode编码为12288，半角空格为32
//其他字符半角(33-126)与全角(65281-65374)的unicode编码对应关系是：均相差65248
//全角转半角
function ToCDB(str) {
  var tmp = "";
  for (var i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 65248 && str.charCodeAt(i) < 65375) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
      }
      else {
          tmp += String.fromCharCode(str.charCodeAt(i));
      }
  }
  return tmp
}
//半角转全角
// if (txtstring.charCodeAt(i) == 32) {
      //     tmp = tmp + String.fromCharCode(12288);
      // }else if (txtstring.charCodeAt(i) < 127) {
      //     tmp = tmp + String.fromCharCode(txtstring.charCodeAt(i) + 65248);
      // }else{
      //   tmp=tmp+txtstring[i]
      // }
function formatEnterpriseName(txtstring) {
  var tmp = "";
  for (var i = 0; i < txtstring.length; i++) {
        if (txtstring[i] == '(' || txtstring[i] == ')') {
            tmp = tmp + String.fromCharCode(txtstring.charCodeAt(i) + 65248);
        }else{
          tmp=tmp+txtstring[i]
        }
  }
  return tmp;
}

export default {
  longToDecimal,
  longToDecimal2,
  DecimalToLong,
  longToInt,
  regexNum,
  ToCDB,
  formatEnterpriseName
}



// WEBPACK FOOTER //
// ./src/utils/digitalConversion.js